<!-- 开票订单数据操作 -->
<template>
   <div>
      <el-drawer id="drawerBox" :close-on-press-escape="true" title="基础信息" :visible.sync="dataActionBox.showStatus" :withHeader="true" :append-to-body="true" custom-class="drawer_box" :wrapperClosable="false"
                 :direction="dataActionBox.openMode" size="100%">
         <div class="demo-drawer__content data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="formDataList">
               <v-tabs :isFlag="true" :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="formDataList" @tabs="(val) => { showTabs = val }"
                       @tabHeight="(val) => { mxHeight = val }">
                  <template slot="tabs" slot-scope="scope">
                     <!-- 提取信息 -->
                     <div v-if="scope.index == 0">
                        <div id="mainInfo">
                           <el-button type="primary" size="mini" @click="getExtractBill">选择单据</el-button>
                           <!-- 发票信息 -->
                           <el-form label-width="100px" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false" style="border-top:1px solid #E4E7ED; padding-top: 10px"
                                    :disabled="dataActionBox.actionType == 1">
                              <el-row>
                                 <el-form-item v-for="(formOneValue, formOneKey) in formDataList[1].jurconfigform" :key="formOneKey" :label="formOneValue.showField" v-if="formOneValue.isShow == 1"
                                               :prop="formOneValue.entityField" :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                    <!-- 系统字段 -->
                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                    <div v-if="formOneValue.isReserved == 0">
                                       <!-- 开票日期 -->
                                       <df-date v-if="formOneValue.fieldType == 'date'" :isShowLong="false" :isdisabled="formOneValue.isChange == 0" v-model="sendDataInfo[formOneValue.entityField]"></df-date>
                                       <el-select clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'" :disabled="formOneValue.isChange == 0" @change="$forceUpdate()"
                                                  v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                          <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.value" :value="item.key">
                                          </el-option>
                                       </el-select>

                                       <el-input v-else-if="formOneValue.entityField == 'remark'" type="textarea" :disabled="formOneValue.isChange == 0" v-model.trim="sendDataInfo[formOneValue.entityField]"
                                                 maxlength="200"></el-input>
                                       <el-input v-else-if="formOneValue.entityField == 'ticketNum'" :disabled="formOneValue.isChange == 0" v-model.trim="sendDataInfo[formOneValue.entityField]"
                                                 :maxlength="$store.state.inputLength">
                                          <template slot="append"><span style="color: red;">{{ sendDataInfo[formOneValue.entityField] == '' ||
                                                   sendDataInfo[formOneValue.entityField] == null ||
                                                   sendDataInfo[formOneValue.entityField] == undefined ? 0 :
                                                sendDataInfo[formOneValue.entityField].length }}位</span></template>
                                       </el-input>
                                       <el-input v-else :disabled="formOneValue.isChange == 0" v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>

                                    </div>
                                 </el-form-item>
                              </el-row>
                           </el-form>
                        </div>
                        <el-row>
                           <el-col :span="9" style="padding-right:10px">
                              <!-- 主单据表 -->
                              <u-table class="list" :data="sendDataInfo.sudocumentsmasterList" :row-height="30" border row-key="index" use-virtual size="mini" :height="mxHeight">

                                 <u-table-column :prop="formOneValue.entityField" :label="formOneValue.showField" v-for="(formOneValue, formOneKey) in formDataList[2].jurconfigform" :key="formOneKey"
                                                 v-if="formOneValue.isShow == 1" show-overflow-tooltip :min-width="formOneValue.fieldWeight">
                                    <template slot="header">
                                       <div>
                                          <el-tooltip :content="formOneValue.showField" placement="top">
                                             <div class="long_title"><span>{{ formOneValue.showField }}</span></div>
                                          </el-tooltip>
                                       </div>
                                    </template>

                                    <template slot-scope="scope">
                                       <!-- 系统字段 -->
                                       <div>
                                          <!-- 显示通用名称 -->
                                          <span v-if="formOneValue.entityField == 'bgmId'">
                                             {{ sendDataInfo.sudocumentsmasterList[scope.$index].bgmName }}</span>

                                          <!-- 生产日期 -->
                                          <template v-else-if="formOneValue.entityField == 'prodate'">
                                             <span v-if="sendDataInfo.sudocumentsmasterList[scope.$index][formOneValue.entityField]">
                                                {{ $common.getLocalTime(scope.row[formOneValue.entityField]) }}
                                             </span>
                                          </template>

                                          <!-- 有效期 -->
                                          <template v-else-if="formOneValue.entityField == 'expidate'">
                                             <span v-if="sendDataInfo.sudocumentsmasterList[scope.$index][formOneValue.entityField]">
                                                {{ $common.getLocalTime(scope.row[formOneValue.entityField]) }}
                                             </span>
                                          </template>
                                          <!-- 购进单位 -->
                                          <span v-else-if="formOneValue.entityField == 'cmId'">{{
                                             sendDataInfo.sudocumentsmasterList[scope.$index].cmName }}</span>
                                          <!-- 业务员 -->
                                          <span v-else-if="formOneValue.entityField == 'opmId'">{{
                                             sendDataInfo.sudocumentsmasterList[scope.$index].opmName }}</span>

                                          <!-- 总金额 -->
                                          <el-input v-else-if="formOneValue.entityField == 'totalMoney'" type="number" v-model="sendDataInfo.sudocumentsmasterList[scope.$index][formOneValue.entityField]"
                                                    @input="calculationAllData" :disabled="dataActionBox.actionType == 1"></el-input>

                                          <!-- 税额 -->
                                          <el-input v-else-if="formOneValue.entityField == 'taxMoney'" type="number" v-model="sendDataInfo.sudocumentsmasterList[scope.$index][formOneValue.entityField]"
                                                    @input="calculationAllData" :disabled="dataActionBox.actionType == 1"></el-input>

                                          <!-- 含税金额 -->
                                          <el-input v-else-if="formOneValue.entityField == 'totalPsmoney'" type="number" v-model="sendDataInfo.sudocumentsmasterList[scope.$index][formOneValue.entityField]"
                                                    @input="calculationAllData" :disabled="dataActionBox.actionType == 1"></el-input>

                                          <span v-else>{{
                                             sendDataInfo.sudocumentsmasterList[scope.$index][formOneValue.entityField]
                                             }}</span>
                                       </div>
                                    </template>
                                 </u-table-column>
                              </u-table>
                           </el-col>
                           <el-col :span="15" style="position: relative;">
                              <!-- 明细信息 -->
                              <input class="checkbox_input checkbox_input1 " v-if="dataActionBox.actionType != 1" :disabled="sendDataInfo.sudocumentsdetailList.length > 0 ? false : true" type="checkbox"
                                     @change="checkAll" v-model="checked" />
                              <u-table class="details" ref="plTableBox" :data="sendDataInfo.sudocumentsdetailList" :height="mxHeight" :row-height="30" row-key="index" use-virtual size="mini"
                                       :highlight-current-row="false" border style="width: 100%">
                                 <u-table-column label="选项" v-if="dataActionBox.actionType != 1" width="60">
                                    <template slot="header">
                                       <div class="checkbox" style="display: flex;justify-content: space-between;">
                                          <span></span>
                                          <el-tooltip class="item" effect="dark" content="删除未选中明细" placement="top">
                                             <i style="font-size: 17px;cursor: pointer;margin-right: 5px;" :disabled="sendDataInfo.sudocumentsdetailList.length > 0 ? false : true" @click.stop="delMxInfo"
                                                class="el-icon-delete"></i>
                                          </el-tooltip>
                                       </div>
                                    </template>
                                    <template slot-scope="scope">
                                       <input class="checkbox_input" type="checkbox" @change="detailSelectionChange" v-model="detailSelectList" :value="scope.row" />
                                    </template>
                                 </u-table-column>
                                 <u-table-column :prop="formOneValue.entityField" :label="formOneValue.showField" v-for="(formOneValue, formOneKey) in formDataList[3].jurconfigform" :key="formOneKey"
                                                 v-if="formOneValue.isShow == 1" show-overflow-tooltip :min-width="formOneValue.fieldWeight">
                                    <template slot="header" slot-scope="scope">
                                       <div>
                                          <el-input class="header" v-if="formOneValue.entityField == 'businessId'" v-model.trim="businessId" size="mini" :placeholder="`输入${formOneValue.showField}搜索`"
                                                    @keyup.enter.native="getData" />
                                          <el-input class="header" v-else-if="formOneValue.entityField == 'bgmName'" v-model.trim="bgmName" size="mini" :placeholder="`输入${formOneValue.showField}搜索`"
                                                    @keyup.enter.native="getData" />
                                          <span v-else>{{ formOneValue.showField }}</span>
                                       </div>
                                    </template>

                                    <template slot-scope="scope">
                                       <!-- 系统字段 -->
                                       <div v-if="formOneValue.isReserved == 0">
                                          <!-- 生产日期 -->
                                          <template v-if="formOneValue.entityField == 'prodate'">
                                             <span v-if="sendDataInfo.sudocumentsdetailList[scope.$index][formOneValue.entityField]">
                                                {{ $common.getLocalTime(scope.row[formOneValue.entityField]) }}
                                             </span>
                                          </template>
                                          <!-- 有效期 -->
                                          <template v-else-if="formOneValue.entityField == 'expidate'">
                                             <span v-if="sendDataInfo.sudocumentsdetailList[scope.$index][formOneValue.entityField]">
                                                {{ $common.getLocalTime(scope.row[formOneValue.entityField]) }}
                                             </span>
                                          </template>

                                          <!-- 开票数量 -->
                                          <input class="kaipiao_num" v-else-if="formOneValue.entityField == 'ddinCount'" @input="calculatePrice(scope.$index)" type="number"
                                                 v-model="sendDataInfo.sudocumentsdetailList[scope.$index][formOneValue.entityField]"
                                                 :min="sendDataInfo.sudocumentsdetailList[scope.$index].ddinCount < 0 ? sendDataInfo.sudocumentsdetailList[scope.$index].treatCount : 0"
                                                 :max="sendDataInfo.sudocumentsdetailList[scope.$index].ddinCount < 0 ? 0 : sendDataInfo.sudocumentsdetailList[scope.$index].treatCount"
                                                 :disabled="dataActionBox.actionType == 1">

                                          <!-- 总金额 -->
                                          <el-input v-else-if="formOneValue.entityField == 'money'" type="number" v-model="sendDataInfo.sudocumentsdetailList[scope.$index][formOneValue.entityField]"
                                                    :disabled="dataActionBox.actionType == 1"></el-input>
                                          <!-- @change="calculatePrice(3,scope.$index)" -->

                                          <!-- 含税金额 -->
                                          <el-input v-else-if="formOneValue.entityField == 'psmoney'" type="number" v-model="sendDataInfo.sudocumentsdetailList[scope.$index][formOneValue.entityField]"
                                                    :disabled="dataActionBox.actionType == 1"></el-input>
                                          <!-- @change="calculatePrice(4,scope.$index)" -->

                                          <!-- 税额 -->
                                          <el-input v-else-if="formOneValue.entityField == 'taxMoney'" type="number" v-model="sendDataInfo.sudocumentsdetailList[scope.$index][formOneValue.entityField]"
                                                    :disabled="dataActionBox.actionType == 1"></el-input>

                                          <!-- 备注 -->
                                          <el-input v-else-if="formOneValue.entityField == 'remark'" v-model.trim="sendDataInfo.sudocumentsdetailList[scope.$index][formOneValue.entityField]"
                                                    :disabled="dataActionBox.actionType == 1"></el-input>

                                          <span v-else>{{
                                             sendDataInfo.sudocumentsdetailList[scope.$index][formOneValue.entityField]}}</span>
                                       </div>
                                       <!-- 扩展字段 -->
                                       <div v-else-if="formOneValue.isReserved == 1">
                                          <!-- 自填 -->
                                          <el-input v-model.trim="sendDataInfo.sudocumentsdetailList[scope.$index][formOneValue.entityField]" v-if="formOneValue.operatType == 0" :maxlength="$store.state.inputLength"
                                                    :disabled="dataActionBox.actionType == 1"></el-input>
                                          <!-- 选择数据来源 -->
                                          <el-input v-model.trim="sendDataInfo.sudocumentsdetailList[scope.$index][formOneValue.entityField]" v-else :maxlength="$store.state.inputLength"
                                                    :disabled="dataActionBox.actionType == 1"></el-input>
                                       </div>
                                    </template>
                                 </u-table-column>

                              </u-table>
                           </el-col>
                        </el-row>

                     </div>
                  </template>
               </v-tabs>
            </el-card>

            <div class="foot">
               <div style="text-align: center;" v-if="formDataList[4]">
                  <el-form :inline="true" :model="sendDataInfo" class="demo-form-inline">
                     <el-form-item :label="itemV.chineseField" v-for="(itemV, itemK) in formDataList[4].jurconfigform" :key="itemK">
                        <el-button type="success">{{ sendDataInfo[itemV.entityField] }}</el-button>
                     </el-form-item>
                  </el-form>
               </div>
               <div style="margin-top:10px;text-align: center;">
                  <el-button type="primary" @click="initActionBox('sendDataInfo', 'invoiceExtractData')">取消</el-button>
                  <el-button type="primary" @click="sendDataAction('sendDataInfo', 'invoiceExtractData')" v-if="dataActionBox.actionType == 0">保存</el-button>
               </div>
            </div>
         </div>
      </el-drawer>
      <el-dialog title="提示" v-if="showDialog" :visible.sync="showDialog" width="70%" :modal-append-to-body="true" :append-to-body="true">
         <el-table :data="dialogList" border style="width: 100%">
            <el-table-column prop="level" label="类型" width="50">
               <template slot-scope="{row}">
                  <span :style="row.level == 0 ? 'color:red' : 'color:#ffd04b'">
                     {{ row.level == 0 ? "拦截" : '预警' }}
                  </span>
               </template>
            </el-table-column>
            <el-table-column prop="data" label="内容" min-width="180">
            </el-table-column>
         </el-table>
         <span slot="footer" class="dialog-footer">
            <el-button size="mini" type="primary" @click="showDialog = false">确 定</el-button>
         </span>
      </el-dialog>
      <!-- 检索方案 -->
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
         <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <!-- 提取方案 -->
      <el-dialog title="提取表单" v-if="DialogExtract" :visible.sync="DialogExtract" width="100%" top="1vh">
         <SalesInvoiceExtract ref="invoiceExtract" :parentType="true" :invoiceExtractData="invoiceExtractData" @invoiceExtractMethods="getExData" />
      </el-dialog>

   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from 'number-precision'
import SearchScheme from "../byComponents/SearchScheme.vue";
import SalesInvoiceExtract from '../byComponents/SalesInvoiceExtract'
export default {
   name: 'salesInvoiceActive1',
   props: [],
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme,
      SalesInvoiceExtract
   },
   data() {
      //这里存放数据
      return {
         dataActionBox: {
            showStatus: false,
            openMode: 'ltr' || 'rtl',
            boxTitle: '新增' || '编辑',
            actionType: 0, // 0新增，1修改
         },
         invoiceExtractData: {
            cmId: '', //开票单位
            cmName: '', //开票单位
            start: '',
            end: '',
         },
         sendDataInfo: {
            invoicingTime: '',  //开票日期
            sudocumentsdetailList: [],
            sudocumentsmasterList: [],
            railNum: "",    //轨号
            remark: "",     //备注
            ticketNum: "",  //发票号
            poolMoney: 0, //总额合计
            capMoeny: '',    //价税合计(大写)
            poolPsmoney: 0, //价税合计 含税总额合计(小写)
            poolTaxmoney: 0, //税额合计
            billType: "",
         },
         detailSelectList: [], //明细选择数据
         showTabs: '',
         formDataList: [],
         selectedDetailsIndex: 0,
         seTitle: "", //检索
         DialogVisible: false,
         seId: 0,
         sField: '',
         showDialog: false,
         dialogList: [],
         DialogExtract: false, //提取
         cmId: '',
         seWidth: '0',
         mxHeight: 0, //动态表格高度
         parentSearchData: {},
         checked: false,
         choiceInfo: {
            sudocumentsdetailList: [],
            sudocumentsmasterList: []
         },
         businessId: "",//明细搜索 //业务单号
         bgmName: "",
         detailsList: [],

      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      businessId() {
         if (this.businessId == "" && this.bgmName == "") {
            this.getData()
         }
      },
      bgmName() {
         if (this.businessId == "" && this.bgmName == "") {
            this.getData()
         }
      },
      detailSelectList() {
         if (this.sendDataInfo.sudocumentsdetailList.length > 0) {
            this.checked = this.detailSelectList.length === this.sendDataInfo.sudocumentsdetailList.length;
         } else {
            this.checked = false;
         }
      },
      "invoiceExtractData.cmName": {
         handler: function (newValue, oldValue) {
            if (newValue == "") {
               this.newInit()
            }
         },
         deep: true,
      },

   },
   //方法集合
   methods: {
      getData() {
         console.log(this.businessId, this.bgmCode);

         var arr = []
         this.detailsList.forEach((item) => {
            var arr1 = this.sendDataInfo.sudocumentsdetailList.filter(val => val.dasdId == item.dasdId)
            if (arr1.length > 0) {
               item = arr1[0]
            }
            if (!this.businessId && !this.bgmName) {
               arr.push(item)
            } else if (!this.businessId && item.bgmName.indexOf(this.bgmName) != -1) {
               arr.push(item)
            } else if (!this.bgmName && item.businessId.toLowerCase().includes(this.businessId.toLowerCase())) {
               arr.push(item)
            } else if (this.businessId && this.bgmName && item.businessId.toLowerCase().includes(this.businessId.toLowerCase()) && item.bgmName.indexOf(this.bgmName) != -1) {
               arr.push(item)

            }
         });
         this.sendDataInfo.sudocumentsdetailList = arr
      },
      changeTime(val) {
         if (val) {
            var time = val + 24 * 60 * 60 * 1000 - 1;
            this.invoiceExtractData.end = time;
         }
      },

      checkAll() {
         if (!this.checked) {
            this.detailSelectList = [];
         } else {
            if (this.detailSelectList.length == 0) {
               this.detailSelectList = JSON.parse(JSON.stringify(this.detailsList))
            } else {
               this.detailsList.forEach((item) => {
                  if (this.detailSelectList.indexOf(item) == -1) {
                     this.detailSelectList.push(item);
                  }
               });
            }
         }
         this.getData()
         this.calculationMainData() //计算主表单数据
      },
      //明细选择触发
      detailSelectionChange() {
         this.calculationMainData() //计算主表单数据
      },
      // 获取 提取单数据
      async getExData(res) {
         let val = JSON.parse(JSON.stringify(res))
         if (val != "" || val != undefined) {
            val.mainData.forEach(v => {
               var arr = this.sendDataInfo.sudocumentsmasterList.filter(item => item.dasmId == v.dasmId)
               if (arr.length <= 0) {
                  this.sendDataInfo.sudocumentsmasterList.push(v)
               }
            })
            val.detailData.forEach((v) => {
               var arr = this.detailsList.filter(item => item.dasdId == v.dasdId)
               if (arr.length <= 0) {
                  this.detailsList.push(JSON.parse(JSON.stringify(v)))
               }
            })
            this.getUnique()
            this.detailSelectList = []
            this.detailsList.forEach((item) => {
               this.$set(item, 'taxMoney', this.$common.getDecimalInfo(3, NP.minus(item.psmoney, item.money)))
               item.psmoney = parseFloat(item.psmoney)
               item.money = parseFloat(item.money)
               if (this.detailSelectList.indexOf(item) == -1) {
                  this.detailSelectList.push(item);
               }
            });
            this.sendDataInfo.sudocumentsdetailList = this.detailsList
            this.calculationMainData() //计算主表单数据
         } else {
         }
         this.DialogExtract = false
      },
      //获取提取单据
      getExtractBill() {
         if (this.invoiceExtractData.cmId == '') {
            this.$message({
               message: '请先选择单位',
               type: 'error'
            })
            return false;
         } else if (!this.invoiceExtractData.start || !this.invoiceExtractData.end) {
            this.$message({
               message: '请填写日期',
               type: 'error'
            })
            return false;
         }
         this.DialogExtract = true;
      },

      getUnique() {//去重
         const map = new Map();
         this.sendDataInfo.sudocumentsdetailList = this.sendDataInfo.sudocumentsdetailList.filter(v => !map.has(v.dasdId) && map.set(v.dasdId, 1));
         let map1 = new Map()
         this.sendDataInfo.sudocumentsmasterList = this.sendDataInfo.sudocumentsmasterList.filter(v => !map1.has(v.businessId) && map1.set(v.businessId, 1));
         console.log(this.sendDataInfo.sudocumentsmasterList)
      },
      getExWidth(e) {
         this.exWidth = e + "%";
      },
      //换行提示
      lineMessageBox(data) {
         let txtArr = data.message.split('<br/>')
         let newArr = []
         const h = this.$createElement
         for (const i in txtArr) {
            newArr.push(h('p', null, txtArr[i]))
         }
         this.$alert(h('div', null, newArr), '提示', {
            confirmButtonText: '确定',
            callback: action => { }
         })
      },
      // 检索Id, 索引(表格中), 标识
      openSearch(sId, index, type, sField) {
         this.DialogVisible = true
         this.seId = sId
         this.sField = sField
         this.parentSearchData[type] = this.invoiceExtractData[type]
         console.log('qqqq', JSON.stringify(this.parentSearchData));
      },
      //检索带回数据
      changeInputModel(val) {
         console.log('检回', val);
         if (val != "" || val != undefined) {
            this.DialogVisible = false;
            this.paramValue(val)
         }
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(',')
         arr.forEach(item => {
            this.invoiceExtractData[item] = val[item]
         })
      },
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      getSearchName(e) {
         this.seTitle = e;
      },

      //确认新增
      async sendDataAction(formName1, formName2) {
         let flag = false
         this.$refs[formName1].validate((valid) => {
            if (valid) {

            } else {
               this.$message({
                  message: '请完善发票号 等信息',
                  type: 'error'
               })
               flag = true
               return false;
            }
         })
         if (flag) return false;

         if (this.sendDataInfo.sudocumentsmasterList.length < 1) {
            this.$message({
               message: '请先提取有效单据',
               type: 'error'
            });
            return false
         }

         for (let j = 0; j < this.detailsList.length; j++) {
            const itemvs = this.detailsList[j];
            if (itemvs.ddinCount == 0) {
               this.$message({
                  message: '请填写合理的开票数量',
                  type: 'error'
               });
               this.$set(itemvs, 'ddinCount', 0)
               return false
            }
         }
         var sendDataInfo1 = JSON.parse(JSON.stringify(this.sendDataInfo))
         sendDataInfo1.sudocumentsdetailList = this.detailsList
         let sendObj = {}
         for (const key in this.sendDataInfo) {
            if (typeof this.sendDataInfo[key] == 'object' || Array.isArray(this.sendDataInfo[key])) {
               if (key == 'sudocumentsdetailList') {
                  sendObj[key] = this.sendDataInfo[key].filter((v) => {
                     for (let j = 0; j < this.detailSelectList.length; j++) {
                        const ele = this.detailSelectList[j]
                        if (v.dasdId == ele.dasdId) return v
                     }
                  })
               } else {
                  sendObj[key] = JSON.parse(JSON.stringify(this.sendDataInfo[key]))
               }
            } else {
               sendObj[key] = this.sendDataInfo[key]
            }
         }
         let responseDataCheck = await this.$http.checkDetail(sendObj)
         console.log(responseDataCheck);
         if (responseDataCheck.status == 200) {
            let flagDialog = -1
            if (responseDataCheck.result != null && responseDataCheck.result.length > 0) {
               this.dialogList = responseDataCheck.result
               flagDialog = this.dialogList.findIndex(item => item.level == 0)
               this.showDialog = true
            }
            let responseData
            if (flagDialog == -1) {
               if (this.dataActionBox.actionType == 0) {
                  responseData = await this.$http.sudocumentsAdd(sendObj)
               } else {
                  responseData = await this.$http.setSalesOrder(sendObj)
               }

               if (responseData.status == 200) {
                  this.$message({
                     message: '操作成功',
                     type: 'success'
                  });

                  if (window.global_config.invoiceShow) {
                     this.newInit()
                  } else {
                     this.init()
                  }
                  if (this.dataActionBox.actionType == 0) {
                  } else {
                     this.dataActionBox.showStatus = false
                     this.$refs[formName1].resetFields()
                     this.$refs[formName2].resetFields()
                  }
                  this.$parent.getDataList()

               } else {
                  let txtArr = responseData.message.split('<br/>')
                  let newArr = []
                  const h = this.$createElement
                  for (const i in txtArr) {
                     newArr.push(h('p', null, txtArr[i]))
                  }
                  this.$message({
                     message: h('div', null, newArr),
                     type: 'error'
                  });
               }
               this.sendDataInfo.invoicingTime = this.$moment().valueOf()
            }
         } else {
            this.$message.error(responseDataCheck.message)
         }

         return

      },
      //明细选择完毕
      detailSelectOver() {
         if (this.detailSelectList.length < 1) {
            this.$message({
               message: '请先选中明细信息',
               type: 'error'
            })
            return false
         }
         this.calculationMainData() //计算主表单数据
      },

      //计算主表单数据
      calculationMainData() {
         this.sendDataInfo.sudocumentsmasterList.forEach((a, i) => { //主单
            let item = this.sendDataInfo.sudocumentsmasterList[i]
            let flag = false    //有无选中明细标识
            this.$set(this.sendDataInfo.sudocumentsmasterList[i], 'totalMoney', 0)    //总额
            this.$set(this.sendDataInfo.sudocumentsmasterList[i], 'totalPsmoney', 0)  //税总额
            this.$set(this.sendDataInfo.sudocumentsmasterList[i], 'taxMoney', 0)      //税额
            var detailSelectList = this.detailSelectList.filter(v => v.businessId == item.businessId)
            if (detailSelectList.length > 0) {
               detailSelectList.forEach(item1 => {
                  flag = true
                  item.totalMoney = NP.plus(item.totalMoney, item1.money)
                  item.totalPsmoney = NP.plus(item.totalPsmoney, item1.psmoney)
                  item.taxMoney = NP.plus(item.taxMoney, item1.taxMoney)
               })
            }
            if (flag) {   //主单有明细
               item.totalMoney = this.$common.getDecimalInfo(3, item.totalMoney) //总额
               item.totalPsmoney = this.$common.getDecimalInfo(3, item.totalPsmoney) //税额
               item.taxMoney = this.$common.getDecimalInfo(3, item.taxMoney) //税
               // item.billMoney = this.$common.getDecimalInfo(3, item.totalMoney) //原总额
            } else {
               item.totalMoney = 0
               item.totalPsmoney = 0
               item.taxMoney = 0
               // item.billMoney = 0
            }
         })
         if (this.detailsList.length == this.sendDataInfo.sudocumentsdetailList.length) {
            this.sendDataInfo.sudocumentsdetailList = this.detailsList
         } else {
            this.detailsList.forEach(ele => { //明细
               let indexs = this.sendDataInfo.sudocumentsdetailList.findIndex(items => items.dasdId == ele.dasdId)
               if (indexs != -1) {
                  this.sendDataInfo.sudocumentsdetailList[indexs] = ele
               }
            })
         }
         this.calculationAllData()  //计算总价
      },

      // 计算价格
      calculatePrice(index) {
         var dataInfo = this.sendDataInfo.sudocumentsdetailList[index]
         var indexs = this.detailsList.findIndex(items => items.dasdId == dataInfo.dasdId)
         this.$set(this.detailsList, indexs, dataInfo)
         var info = this.detailsList[indexs]
         if (info.ddinCount < 0) {
            if (info.ddinCount < info.treatCount) {
               this.$message({
                  message: '开票数量不能小于待开票数量',
                  type: 'error'
               })
               info.ddinCount = info.treatCount
            } else if (info.ddinCount > 0) {
               this.$message({
                  message: '开票数量不能大于 0',
                  type: 'error'
               })
               info.ddinCount = info.treatCount
            }
         } else {
            if (info.ddinCount > info.treatCount) {
               this.$message({
                  message: '开票数量不能大于待开票数量',
                  type: 'error'
               })
               info.ddinCount = info.treatCount
            } else if (info.ddinCount < 0) {
               this.$message({
                  message: '开票数量不能小于 0',
                  type: 'error'
               })
               info.ddinCount = info.treatCount
            }
         }

         info.price = parseFloat(info.price) //单价
         info.psprice = parseFloat(info.psprice) //含税单价
         info.money = parseFloat(info.money) //金额
         info.psmoney = parseFloat(info.psmoney) //含税金额
         info.outRate = parseFloat(info.outRate) //销项税率
         // info.ddinCount = parseFloat(info.ddinCount) //开票数量
         this.$set(this.detailsList[indexs], 'taxMoney', 0)
         //   NP.strip(0.09999999999999998); // = 0.1
         //   NP.plus(a, b); //加法 a+b          
         //   NP.minus(a, b);  //减法  a-b       
         //   NP.times(a, b);      //乘法  a*b    
         //   NP.divide(a, b);   //除法  a/b     
         //   NP.round(a, b);      //a代表取整 b代表取几位小数
         let newMoney = NP.divide(info.psmoney, NP.plus(NP.divide(info.outRate, 100), 1))
         //金额=单价*开票数量
         console.log(this.sendDataInfo)
         this.detailsList[indexs].money = this.$common.getDecimalInfo(3, NP.times(info.price, info.ddinCount))
         //含税金额=含税价格*数量
         this.detailsList[indexs].psmoney = this.$common.getDecimalInfo(3, NP.times(info.psprice, info.ddinCount))
         // console.log("含税金额:", info.psmoney, "金额:", info.money,"税额:",NP.minus(info.psmoney, info.money));
         // 税额 = 含税金额 - 金额   绝对值
         this.detailsList[indexs].taxMoney = this.$common.getDecimalInfo(3, NP.minus(info.psmoney, info.money))
         if (this.detailSelectList.length > 0) {
            var arr = this.detailSelectList.filter(item => item.dasmId == this.detailsList[indexs].dasmId)
            if (arr.length > 0) {
               this.calculationMainData() //计算主表单数据
            }
         }
         this.sendDataInfo.sudocumentsdetailList[index] = this.detailsList[indexs]
      },
      //计算总价
      calculationAllData() {   //页脚
         var arr = this.sendDataInfo.sudocumentsmasterList
         this.sendDataInfo.poolMoney = 0
         this.sendDataInfo.poolPsmoney = 0
         this.sendDataInfo.poolTaxmoney = 0
         arr.forEach((v, i) => {
            this.sendDataInfo.poolMoney = NP.plus(this.sendDataInfo.poolMoney, v.totalMoney) //总额合计
            this.sendDataInfo.poolPsmoney = NP.plus(this.sendDataInfo.poolPsmoney, v.totalPsmoney) //价税合计 含税总额合计(小写)
            this.sendDataInfo.poolTaxmoney = NP.plus(this.sendDataInfo.poolTaxmoney, v.taxMoney) //税额合计
         })
         this.sendDataInfo.poolMoney = this.$common.getDecimalInfo(3, this.sendDataInfo.poolMoney)
         this.sendDataInfo.poolPsmoney = this.$common.getDecimalInfo(3, this.sendDataInfo.poolPsmoney)
         this.sendDataInfo.poolTaxmoney = this.$common.getDecimalInfo(3, this.sendDataInfo.poolTaxmoney)
         this.sendDataInfo.capMoeny = this.changeNumMoneyToChinese(this.sendDataInfo.poolPsmoney)    //价税合计(大写)
         this.tiao(1)
      },

      //取消
      initActionBox(formName1, formName2) {
         if (this.dataActionBox.actionType == 1) {
            this.dataActionBox.showStatus = false
            this.init()
            this.$refs[formName1].resetFields()
            this.$refs[formName2].resetFields()
         } else {
            this.$confirm('确定取消' + this.dataActionBox.boxTitle + '吗?', '提示', {
               confirmButtonText: '确定',
               cancelButtonText: '取消',
               type: 'warning'
            }).then(() => {
               this.dataActionBox.showStatus = false
               this.init()
               this.$refs[formName1].resetFields()
               this.$refs[formName2].resetFields()
            }).catch(() => { })
         }
      },
      newInit() {
         this.invoiceExtractData.cmName = ''
         this.invoiceExtractData.cmId = ''
         for (let key in this.sendDataInfo) {
            if (key == 'sudocumentsmasterList' || key == 'sudocumentsdetailList') {
               this.sendDataInfo[key] = []
            } else if (key == 'poolMoney' || key == 'poolPsmoney' || key == 'poolTaxmoney') {
               this.sendDataInfo[key] = 0
            } else if (key == 'capMoeny') {
               this.sendDataInfo[key] = '零'
            } else if (key == 'ticketNum' || key == 'railNum' || key == 'remark') {
               this.sendDataInfo[key] = ''
            }
         }
         this.checked = false
         this.detailsList = []
         this.detailSelectList = []
      },
      delMxInfo() {
         if (this.detailsList.length == this.detailSelectList.length) return
         this.detailsList = JSON.parse(JSON.stringify(this.detailSelectList))
         this.sendDataInfo.sudocumentsmasterList = this.sendDataInfo.sudocumentsmasterList.filter(item => {
            const index = this.detailsList.findIndex(items => items.dasmId == item.dasmId)
            if (index != -1) {
               return true
            } else {
               return false
            }
         })
         this.checked = true
         this.getData()
         this.$forceUpdate()
      },
      //初始化
      init() {
         for (const key in this.invoiceExtractData) {
            this.invoiceExtractData[key] = ''
         }
         for (let key in this.sendDataInfo) {
            if (key == 'sudocumentsmasterList' || key == 'sudocumentsdetailList') {
               this.sendDataInfo[key] = []
            } else {
               this.sendDataInfo[key] = ''
            }
         }
         this.checked = false
         this.invoiceExtractData.start = this.$common.getStartTime()
         this.invoiceExtractData.end = this.$common.getEndTime()
         this.sendDataInfo.invoicingTime = this.$moment().valueOf()
         this.detailsList = []
         this.detailSelectList = []
         this.dataActionBox.actionType = 0
      },

      async isShowData(name, value) {
         switch (name) {
            case 'woamSalecus':
               var dataInfo = sessionStorage.getItem('selectCustomerData')
               if (dataInfo) {
                  dataInfo = JSON.parse(dataInfo)
                  this.sendDataInfo.woamSalecus = dataInfo.cmId
                  this.sendDataInfo.woamSalecusName = dataInfo.cmName

               }
               this.sendDataInfo.woamOpposalesman = ''
               break;
            case 'cargoOwner':
               var dataInfo = sessionStorage.getItem('selectCargoOwnerData')
               // console.log(dataInfo)
               if (dataInfo) {
                  dataInfo = JSON.parse(dataInfo)
               }
               break;
            default:
               this.sendDataInfo[name] = value
         }
      },

      //上级流入
      openBox(cate, formData, oldData = '') {
         this.showTabs = formData[0].jciName
         this.formDataList = formData
         oldData = JSON.parse(JSON.stringify(oldData))
         this.filterMainField()
         if (cate == 0) {
            this.dataActionBox.boxTitle = '新增信息'
            this.dataActionBox.openMode = 'ltr'
         } else {
            this.dataActionBox.boxTitle = '编辑信息'
            this.dataActionBox.openMode = 'rtl'
            this.sendDataInfo = oldData
            this.invoiceExtractData['cmId'] = oldData.cmId
            this.invoiceExtractData['cmName'] = oldData.cmName
            this.sendDataInfo.sudocumentsmasterList = []
            this.sendDataInfo.sudocumentsdetailList = []
            this.detailsList = []
            this.$http.sudocumentsQueryDetail({
               railNum: oldData.railNum,  //	轨号
               ticketNum: oldData.ticketNum,  //	发票号
            }).then((res) => {
               if (res.status == 200) {
                  var resData = res.result
                  this.sendDataInfo.sudocumentsmasterList = resData.sudocumentsmasterList
                  this.sendDataInfo.sudocumentsdetailList = resData.sudocumentsdetailList
                  this.detailsList = this.sendDataInfo.sudocumentsdetailList
               }
            })
         }
         this.tiao()
         this.dataActionBox.actionType = cate
         this.dataActionBox.showStatus = true
         console.log('open-sendDataInfo', this.sendDataInfo);
      },
      findByJciId(list, id) {
         return list.find(item => item.jciId === id) || {};
      },
      filterMainField() {
         const JCI_IDS = {
            MASTER: 11535,
            DETAIL: 11536
         };
         const FIELD_DEFINITIONS = [
            { entityField: "sudocumentsmasterList" },
            { entityField: "sudocumentsdetailList" }
         ];
         // ===================================
         // 主处理逻辑
         // ===================================
         // 获取提取查询配置项
         const masterRecord = this.findByJciId(this.formDataList, JCI_IDS.MASTER);
         // 获取发票信息配置项
         const detailRecord = this.findByJciId(this.formDataList, JCI_IDS.DETAIL);
         // 执行字段过滤操作
         const filteredMasterData = this.$common.filterMainFields([], FIELD_DEFINITIONS, detailRecord);
         const filteredDetailData = this.$common.filterMainFields([], [], masterRecord);

         // 安全地合并到目标对象中（确保响应式更新）
         Object.keys(filteredMasterData).forEach(key => {
            this.$set(this.sendDataInfo, key, filteredMasterData[key]);
         });

         Object.keys(filteredDetailData).forEach(key => {
            this.$set(this.invoiceExtractData, key, filteredDetailData[key]); // 修正了这里应该用 filteredDetailData
         });
         this.checked = false
         this.invoiceExtractData.start = this.$common.getStartTime()
         this.invoiceExtractData.end = this.$common.getEndTime()
         this.sendDataInfo.invoicingTime = this.$moment().valueOf()
         this.detailsList = []
         this.detailSelectList = []
      },
      tiao() {
         this.$nextTick(() => {
            setTimeout(() => {
               if (this.dataActionBox.actionType != 2) {
                  this.mxHeight = this.$common.getBtnHeight()
               } else {
                  this.mxHeight = this.$common.getHeight()
               }
            }, 16.7)
         })
      },
      //数字转中文大写
      changeNumMoneyToChinese(money) {
         var cnNums = new Array("零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"); //汉字的数字
         var cnIntRadice = new Array("", "拾", "佰", "仟"); //基本单位
         var cnIntUnits = new Array("", "万", "亿", "兆"); //对应整数部分扩展单位
         var cnDecUnits = new Array("角", "分", "毫", "厘"); //对应小数部分单位
         var cnInteger = "整"; //整数金额时后面跟的字符
         var cnIntLast = "元"; //整型完以后的单位
         var maxNum = 999999999999999.9999; //最大处理的数字
         var IntegerNum; //金额整数部分
         var DecimalNum; //金额小数部分
         var ChineseStr = ""; //输出的中文金额字符串
         var parts; //分离金额后用的数组，预定义    
         var Symbol = "";//正负值标记
         if (money == "") {
            return "零";
         }

         money = parseFloat(money);
         if (money >= maxNum) {
            alert('超出最大处理数字');
            return "";
         }
         if (money == 0) {
            ChineseStr = cnNums[0] + cnIntLast + cnInteger;
            return ChineseStr;
         }
         if (money < 0) {
            money = -money;
            Symbol = "负 ";
         }
         money = money.toString(); //转换为字符串
         if (money.indexOf(".") == -1) {
            IntegerNum = money;
            DecimalNum = '';
         } else {
            parts = money.split(".");
            IntegerNum = parts[0];
            DecimalNum = parts[1].substr(0, 4);
         }
         if (parseInt(IntegerNum, 10) > 0) { //获取整型部分转换
            var zeroCount = 0;
            var IntLen = IntegerNum.length;
            for (var i = 0; i < IntLen; i++) {
               var n = IntegerNum.substr(i, 1);
               var p = IntLen - i - 1;
               var q = p / 4;
               var m = p % 4;
               if (n == "0") {
                  zeroCount++;
               }
               else {
                  if (zeroCount > 0) {
                     ChineseStr += cnNums[0];
                  }
                  zeroCount = 0; //归零
                  ChineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
               }
               if (m == 0 && zeroCount < 4) {
                  ChineseStr += cnIntUnits[q];
               }
            }
            ChineseStr += cnIntLast;
            //整型部分处理完毕
         }
         if (DecimalNum != '') { //小数部分
            var decLen = DecimalNum.length;
            for (var i = 0; i < decLen; i++) {
               var n = DecimalNum.substr(i, 1);
               if (n != '0') {
                  ChineseStr += cnNums[Number(n)] + cnDecUnits[i];
               }
            }
         }
         if (ChineseStr == '') {
            ChineseStr += cnNums[0] + cnIntLast + cnInteger;
         } else if (DecimalNum == '') {
            ChineseStr += cnInteger;
         }
         ChineseStr = Symbol + ChineseStr;

         return ChineseStr;
      },

   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() { },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() { },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() { }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
::v-deep .el-drawer .el-drawer__header {
   height: 0;
   padding: 0;
   margin: 0;
   overflow: hidden;
}

.detailForm {
   margin-bottom: 0.2rem;
   display: flex;
   flex-direction: row;
   flex-wrap: nowrap;
   align-items: center;
}

.detailForm .el-input {
   width: auto;
}

.table_button_box {
   height: 200px;
   background-color: red;
}

/* .table_content_box {
    height: 500px !important;
    overflow-y: auto;
} */

.el-row {
   display: flex;
   flex-wrap: wrap;
   padding-right: 20px;
}

.foot {
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-items: center;
   background: #fff;
   padding: 5px 0;
   z-index: 999;
}

.el-drawer {
   outline: none;
}

.kaipiao_num {
   background-color: #fff;
   background-image: none;
   border-radius: 4px;
   border: 1px solid #dcdfe6;
   box-sizing: border-box;
   color: #606266;
   display: inline-block;
   height: 15px !important;
   line-height: 15px !important;
   padding: 0 3px !important;
   outline: 0;
}

::v-deep .plTableBox .el-table .cell {
   padding: 0 !important;
   white-space: nowrap !important;
   overflow: hidden !important;
   text-overflow: ellipsis !important;
   height: 20px !important;
   line-height: 20px !important;
}

.filtrate {
   position: relative;
}

.filtrate :hover {
   color: #409eff !important;
}

.details ::v-deep .el-input__inner {
   height: 20px !important;
   line-height: 20px !important;
   padding: 0 3px !important;
   padding-right: 20px !important;
}

.list ::v-deep .el-input__inner {
   height: 20px !important;
   line-height: 20px !important;
   padding: 0 3px !important;
   padding-right: 20px !important;
}

.header ::v-deep .el-input__inner {
   height: 18px !important;
   line-height: 18px !important;
   padding: 0 3px !important;
   padding-right: 20px !important;
}

.checkbox_input1 {
   position: absolute;
   top: 5px;
   left: 5px;
   z-index: 999;
}
</style>
